import IdentityService from '@/services/identity';
import { setGtmUserId } from '@/helpers/gtm';
import { getApp } from '@/helpers/core';

const app = getApp();
if (app) {
  IdentityService.initIdentity(app);
  const tempUserId = IdentityService.getTempUserId() as string;
  setGtmUserId(tempUserId);
}
